import { TranscriptComponent } from "./TranscriptComponent";

export class Transcript {
  public id: number;
  public title: string;
  public transcriptDate: Date;
  public components: TranscriptComponent[];

  constructor(transcript: any) {
    this.id = transcript.id;
    this.title = transcript.title;
    this.transcriptDate = new Date(transcript.transcriptDate);
    this.components = transcript.components.map(
      (component: any) => new TranscriptComponent(component),
    );
  }
}
